export default `
  {
    memberJudge {
     memberJudge{
        type
        sub_type
        severity
        max_denounces
        denounces_available
        due_date
}
    }
  }
`;
